
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M4.9 6.65a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5zM4.9 0A4.9 4.9 0 000 4.9C0 8.575 4.9 14 4.9 14s4.9-5.425 4.9-9.1A4.9 4.9 0 004.9 0z"}})])
          )
        }
      }
    